/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import store from '@/store';
import * as api from '@/api/user';
import { USER } from '@/store/types';
import { finalizeAction } from '@/store/actions';
import { UserVerify } from '@/api/types/user';

export interface StoreUserVerifyDetailState {
  id: number;
  info: UserVerify;
}

export default {
  namespaced: true,
  state: {
    id: null,
    info: null,
  },
  getters: {},
  actions: {
    [USER.GET_VERIFIED_INFO]({ state, commit, rootState }, { id, action: rawAction }) {
      if (id === 'mine' && rootState.user.user.id) {
        id = rootState.user.user.id;
      }
      const action = finalizeAction(rawAction, state.id === id);
      if (action) {
        return new Promise((resolve, reject) => {
          api.getVerifiedInfo(id === rootState.user.user.id ? 'mine' : id).then((res) => {
            commit(USER.GET_VERIFIED_INFO, {
              id,
              info: res.data,
            });
            resolve();
          }).catch(reject);
        });
      }
      return Promise.resolve();
    },
    [USER.POST_VERIFIED_INFO]({ dispatch }, { id, info }) {
      return new Promise((resolve, reject) => {
        api.postVerifiedInfo(info).then(() => {
          dispatch(USER.GET_VERIFIED_INFO, {
            id,
            action: 'reload',
          }).then(resolve);
        }).catch(reject);
      });
    },
    [USER.PUT_VERIFIED_INFO]({ dispatch }, { id, state }) {
      return new Promise((resolve, reject) => {
        api.putVerifiedInfo(id, state).then(() => {
          store.commit(`user/verify/list/${USER.PUT_VERIFIED_INFO}`, id);
          dispatch(USER.GET_VERIFIED_INFO, {
            id,
            action: 'refresh',
          }).then(resolve);
        }).catch(reject);
      });
    },
  },
  mutations: {
    [USER.GET_VERIFIED_INFO](state, { id, info }) {
      state.id = id;
      state.info = info;
    },
  },
};
